var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
//src\services\creation\TextCreation.ts
import * as THREE from 'three';
import { FontLoader } from 'three-stdlib';
import { TextGeometry } from 'three-stdlib';
export function createTextSpriteOld(message, textScale, position = null, canvasScale = 5, font = '48px Arial', color = '#8e47ff', // Default to purple
outlineColor = '#191dfa' // Default to blue
) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const scale = window.devicePixelRatio * canvasScale; // Increase scale factor for better definition
    context.font = font;
    let metrics = context.measureText(message);
    const width = metrics.width + 20;
    const height = parseInt(font, 10) + 10; // Adjust height based on font size
    canvas.width = width * scale;
    canvas.height = height * scale;
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;
    context.scale(scale, scale);
    context.clearRect(0, 0, width * scale, height * scale); // Ensure the background is clear
    context.font = font;
    context.textBaseline = 'top';
    context.strokeStyle = outlineColor; // Use string directly
    context.lineWidth = 4;
    context.strokeText(message, 10, 5);
    context.fillStyle = color; // Use string directly
    context.fillText(message, 10, 5);
    const texture = new THREE.CanvasTexture(canvas);
    texture.minFilter = THREE.LinearFilter;
    texture.needsUpdate = true;
    // Adjust material properties for better depth and transparency handling
    const material = new THREE.SpriteMaterial({
        map: texture,
        transparent: true,
        depthTest: true,
        depthWrite: false,
        blending: THREE.CustomBlending,
        blendEquation: THREE.AddEquation,
        blendSrc: THREE.SrcAlphaFactor,
        blendDst: THREE.OneMinusSrcAlphaFactor
    });
    const sprite = new THREE.Sprite(material);
    sprite.scale.set(0.1 * width * textScale, 0.1 * height * textScale, 1);
    // Set sprite position from the provided Vector3
    if (position != null) {
        sprite.position.copy(position);
    }
    return sprite;
}
export function createTextSprite(message, textScale, position = null, canvasScale = 5, font = '48px Arial', color = '#8e47ff', outlineColor = '#191dfa') {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const scale = window.devicePixelRatio * canvasScale;
    context.font = font;
    const metrics = context.measureText(message);
    const textWidth = metrics.width;
    const textHeight = parseInt(font, 10);
    const margin = 40;
    canvas.width = (textWidth + margin * 2) * scale;
    canvas.height = (textHeight + margin * 2) * scale;
    canvas.style.width = `${canvas.width / scale}px`;
    canvas.style.height = `${canvas.height / scale}px`;
    context.scale(scale, scale);
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.font = font;
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    const centerX = canvas.width / (2 * scale);
    const centerY = canvas.height / (2 * scale);
    context.strokeStyle = outlineColor;
    context.lineWidth = 4;
    context.strokeText(message, centerX, centerY);
    context.fillStyle = color;
    context.fillText(message, centerX, centerY);
    const texture = new THREE.CanvasTexture(canvas);
    texture.minFilter = THREE.LinearFilter;
    texture.needsUpdate = true;
    const material = new THREE.SpriteMaterial({
        map: texture,
        transparent: true,
        depthTest: true,
        depthWrite: false
    });
    const sprite = new THREE.Sprite(material);
    sprite.scale.set((canvas.width / scale) * 0.1 * textScale, (canvas.height / scale) * 0.1 * textScale, 1);
    if (position)
        sprite.position.copy(position);
    // ✅ Store metadata for later updates (like in speedTextEffect)
    sprite.userData._canvas = canvas;
    sprite.userData._context = context;
    sprite.userData._scale = scale;
    sprite.userData._margin = margin;
    return sprite;
}
export function createText(text) {
    return new Promise((resolve, reject) => {
        const loader = new FontLoader();
        let textMesh1 = null;
        loader.load('./src/assets/fonts/open-sans/Open Sans_Regular.json', function (font) {
            console.log(font);
            const geometry = new TextGeometry(text, {
                font: font,
                size: 5,
                height: 1,
                curveSegments: 10,
                bevelEnabled: false,
                bevelOffset: 0,
                //bevelSegments: 1,
                bevelSize: 0.3,
                bevelThickness: 1
            });
            const materials = [
                new THREE.MeshPhongMaterial({ color: 0xff6600 }),
                new THREE.MeshPhongMaterial({ color: 0x0000ff }) // side
            ];
            textMesh1 = new THREE.Mesh(geometry, materials);
            //textMesh1.position.y += 1000
            //textMesh1.position.x -= 600
            textMesh1.position.z -= 1000;
            //textMesh1.rotation.y = 0.25
            console.log("made it here");
            resolve(textMesh1);
        }, undefined, reject);
    });
}
export function createTextWithPanel(text, margin, position) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            console.time("Font Loading");
            const loader = new FontLoader();
            loader.load('./src/assets/fonts/open-sans/Open Sans_Regular.json', (font) => {
                console.timeEnd("Font Loading");
                try {
                    const textGeometry = new TextGeometry(text, {
                        font: font,
                        size: 5,
                        height: 1,
                        curveSegments: 10,
                        bevelEnabled: false,
                    });
                    textGeometry.computeBoundingBox();
                    const textMaterials = [
                        new THREE.MeshPhongMaterial({ color: 0x2289e3 }),
                        new THREE.MeshPhongMaterial({ color: 0x0000ff })
                    ];
                    const textMesh = new THREE.Mesh(textGeometry, textMaterials);
                    const textWidth = textGeometry.boundingBox.max.x - textGeometry.boundingBox.min.x;
                    const textHeight = textGeometry.boundingBox.max.y - textGeometry.boundingBox.min.y;
                    const planeWidth = textWidth + margin * 2;
                    const planeHeight = textHeight + margin * 2;
                    const planeGeometry = new THREE.PlaneGeometry(planeWidth, planeHeight);
                    const planeMaterial = new THREE.MeshBasicMaterial({ color: 0xc1c8f7, opacity: 0, side: THREE.DoubleSide });
                    const planeMesh = new THREE.Mesh(planeGeometry, planeMaterial);
                    planeMesh.position.set(textGeometry.boundingBox.min.x + (textWidth / 2), textGeometry.boundingBox.max.y - (textHeight / 2), textMesh.position.z - 1);
                    const group = new THREE.Group();
                    group.add(textMesh);
                    group.add(planeMesh);
                    group.position.copy(position);
                    resolve(group);
                }
                catch (error) {
                    reject(error);
                }
            }, undefined, reject);
        });
    });
}
/**
export function createTextSpriteMultiline(
  message: string[],
  textScale: number,
  fontUrl: string = 'fonts/helvetiker_bold.typeface.json',
  color: number = 0xffffff
): THREE.Mesh {
  
  const loader = new FontLoader();
  const font = loader.load(fontUrl);
  
  const textGeometry = new TextGeometry(message.join('\n'), {
      font: font,
      size: 1, // Size of the text (will be scaled by textScale)
      height: 0.1, // Depth of the text
      curveSegments: 12,
      bevelEnabled: false,
  });

  textGeometry.computeBoundingBox();
  const textWidth = textGeometry.boundingBox.max.x - textGeometry.boundingBox.min.x;
  const textHeight = textGeometry.boundingBox.max.y - textGeometry.boundingBox.min.y;

  const textMaterial = new THREE.MeshBasicMaterial({ color: color });
  const textMesh = new THREE.Mesh(textGeometry, textMaterial);

  // Center the text horizontally
  textMesh.position.x = -textWidth / 2;
  // Center the text vertically
  textMesh.position.y = -textHeight / 2;

  // Scale the text according to the desired size
  textMesh.scale.set(textScale, textScale, textScale);

  return textMesh;
}
 */
// AI slop below
export function createTextMesh(text, position = new THREE.Vector3(), color = 0xffffff, size = 5, height = 1) {
    return __awaiter(this, void 0, void 0, function* () {
        const loader = new FontLoader();
        return new Promise((resolve, reject) => {
            loader.load('./src/assets/fonts/open-sans/Open Sans_Regular.json', (font) => {
                const geometry = new TextGeometry(text, {
                    font,
                    size,
                    height,
                    curveSegments: 10
                });
                const material = new THREE.MeshBasicMaterial({ color });
                const mesh = new THREE.Mesh(geometry, material);
                mesh.position.copy(position);
                resolve(mesh);
            }, undefined, reject);
        });
    });
}
export function createTextCurve(text, center, radius, scale = 2, arc = Math.PI) {
    const sprites = [];
    for (let i = 0; i < text.length; i++) {
        const angle = (i / (text.length - 1)) * arc - arc / 2;
        const x = Math.cos(angle) * radius;
        const z = Math.sin(angle) * radius;
        const pos = center.clone().add(new THREE.Vector3(x, 0, z));
        const sprite = createTextSprite(text[i], scale, pos);
        sprite.lookAt(center);
        sprites.push(sprite);
    }
    return sprites;
}
export function createRainbowText(text, startPos, scale = 2, spacing = 80) {
    const colors = [
        '#ff0000', '#ff8000', '#ffff00', '#00ff00',
        '#00ffff', '#0000ff', '#8000ff'
    ];
    return text.split('').map((char, i) => {
        const color = colors[i % colors.length];
        const pos = startPos.clone().add(new THREE.Vector3(i * spacing, 0, 0));
        return createTextSprite(char, scale, pos, 5, '48px Arial', color);
    });
}
/**
 * Animates a text sprite one word at a time at a given speed
 */
export function startSpeedTextEffect(sprite, text, options = {}) {
    var _a;
    const { font = '48px Arial', fillStyle = '#8e47ff', outlineStyle = '#191dfa', outlineWidth = 4, backgroundColor = 'rgba(0, 0, 0, 0)', textAlign = 'center', baseline = 'middle', wpm = 300, loop = false // this seems to cause massive fps drops. and it is incapabled of looping intelligently across mutlipel in a performant way. set to false for now //TODO find a better way
     } = options;
    const words = text.split(/\s+/).filter(Boolean);
    const interval = 60000 / wpm;
    let index = 0;
    const canvas = sprite.userData._canvas;
    const context = sprite.userData._context;
    const scale = (_a = sprite.userData._scale) !== null && _a !== void 0 ? _a : window.devicePixelRatio * 5;
    stopSpeedTextEffect(sprite);
    if (!canvas || !context) {
        console.warn('SpeedTextEffect: canvas/context missing in sprite.userData');
        return;
    }
    const updateText = () => {
        const word = words[index];
        context.clearRect(0, 0, canvas.width, canvas.height);
        context.fillStyle = backgroundColor;
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.font = font;
        context.textAlign = textAlign;
        context.textBaseline = baseline;
        const centerX = canvas.width / scale / 2;
        const centerY = canvas.height / scale / 2;
        if (outlineStyle && outlineWidth > 0) {
            context.strokeStyle = outlineStyle;
            context.lineWidth = outlineWidth;
            context.strokeText(word, centerX, centerY);
        }
        context.fillStyle = fillStyle;
        context.fillText(word, centerX, centerY);
        sprite.material.map.needsUpdate = true;
        index++;
        if (index >= words.length) {
            if (loop)
                index = 0;
            else
                return;
        }
        sprite.userData._speedTextTimeoutId = window.setTimeout(updateText, interval);
    };
    updateText();
}
export function stopSpeedTextEffect(sprite) {
    const timerId = sprite.userData._speedTextTimeoutId;
    if (timerId !== undefined) {
        clearTimeout(timerId);
        delete sprite.userData._speedTextTimeoutId;
    }
}
